import React from "react";
import { useSettingsListFilters } from "./useListFilter/useListFilter";
import styles from "./listFilterWrapper/listFilterWrapper.css";
import classNames from "classnames";
import { L10n } from "@fidget/common/i18n";
import { useFilterWrapper } from "./listFilterWrapper/useFilterWrapper";

interface Props<T> {
  filterId: string;
  description: string;
  predicate(t: T): boolean;
  antagonistFilterId?: string;
}

export const BooleanListFilter = <T extends unknown>(props: Props<T>) => {
  const { filterId, description, predicate, antagonistFilterId } = props;

  const { activeFilters, deactivateFilter } = useSettingsListFilters<T>();
  const { selectedFilters, selectFilter, deselectFilter } = useFilterWrapper<T>();

  const isActive = !!selectedFilters[filterId] || !!activeFilters[filterId];

  const handleClick = () => {
    if (isActive) {
      if (!!activeFilters[filterId]) {
        deactivateFilter(filterId);
      }
      if (!!selectedFilters[filterId]) {
        deselectFilter(filterId);
      }
    } else {
      selectFilter({
        predicate,
        description,
        filterId,
        antagonistId: antagonistFilterId
      });
    }
  };

  return (
    <>
      <div
        className={classNames(styles["entry-container"], { [styles.selected]: isActive })}
        onClick={handleClick}
      >
        {description}
        {isActive && (
          <div className={styles.applied}>
            <L10n id={"inbox.moreFilters.applied"} />
          </div>
        )}
      </div>
    </>
  );
};
